var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 224,
    viewBox: "0 0 223 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6628 162.018C17.898 144.861 6.56864 85.0012 0.915554 41.4585C0.14283 35.5003 -0.443986 29.1588 0.450747 23.0293C1.03174 19.0495 5.28464 17.1612 7.63477 19.6304C7.84393 19.8512 8.05018 20.0459 8.24481 20.2027C6.51344 17.4285 8.32905 12.3157 11.4548 11.1711C14.5806 10.0266 18.1624 14.2737 17.4246 17.9514C16.4688 16.7632 18.3774 14.4625 19.7892 14.8372C21.2039 15.212 21.8633 16.9317 22.363 18.4917C35.5051 59.4897 45.6028 102.228 52.5283 146.142C64.735 161.431 60.9295 183.968 38.6628 162.018Z",
    fill: "#1A1718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7348 19.8135C29.2246 56.3407 35.9409 95.8513 43.0349 133.889C43.2702 135.156 41.5563 136.146 41.3094 134.862C37.9222 117.116 33.5298 100.194 30.9967 82.1224C28.0191 60.8608 20.4661 41.4905 18.0172 20.104C17.9678 19.6334 18.6098 19.3778 18.7348 19.8135Z",
    fill: "#EBEBEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37264 20.438C11.693 32.9962 14.5399 45.8508 17.1341 58.746C19.7979 72.0014 24.1438 84.5654 26.4562 97.9254C26.523 98.306 26 98.4832 25.8838 98.1578C21.5845 85.8756 19.644 71.9869 16.2248 59.1846C12.8841 46.6729 9.87742 33.9055 7.31813 21.0335C7.16417 20.2695 8.16639 19.6595 8.37264 20.438Z",
    fill: "#EBEBEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4211 40.6596C21.7966 56.7299 26.2151 72.1757 29.9887 88.0369C30.0526 88.3012 29.7214 88.49 29.6284 88.2402C24.048 73.5962 20.6695 56.9129 18.1945 40.7496C18.1712 40.6044 18.392 40.5143 18.4211 40.6596Z",
    fill: "#EBEBEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.089 74.5694C221.441 77.1287 219.134 80.7802 215.155 84.5828C215.152 84.5858 215.152 84.5858 215.146 84.5858C211.939 87.6476 207.645 90.8111 202.265 93.5679C202.265 93.5679 210.591 94.6195 207.924 99.4854H207.921C206.803 101.528 203.741 104.244 197.306 107.84C197.306 107.84 204.955 107.422 196.365 116.018C187.781 124.611 170.337 133.337 163.623 135.26C159.187 136.527 156.5 135.862 155.774 133.877C155.399 132.846 155.55 131.463 156.262 129.816C156.262 129.816 167.981 102.257 173.878 92.4495C179.775 82.6336 208.865 74.7727 217.94 71.4523C221.432 70.18 222.824 71.6731 222.089 74.5694Z",
    fill: "#1A1718"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.086 74.5695C210.521 81.0824 186.686 89.0043 181.753 93.0887C175.13 98.5733 175.484 109.104 172.013 115.108C169.465 119.533 160.384 129.119 155.768 133.875C155.393 132.846 155.544 131.463 156.256 129.813C156.256 129.813 167.969 102.254 173.872 92.4467C179.766 82.6337 208.859 74.7699 217.938 71.4524C221.432 70.1801 222.824 71.6703 222.086 74.5695Z",
    fill: "#1A1718"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.811 193.034C163.466 193.976 156.788 200.134 150.992 204.864C145.197 209.593 140.476 222.932 139.239 220.76C138.001 218.59 145.252 206.752 145.252 206.752C144.052 204.547 141.476 201.319 139.015 198.452C136.04 194.987 133.237 192.035 133.237 192.035C133.237 192.035 131.119 189.095 133.931 191.045C135.175 191.907 137.856 194.821 140.462 197.796C143.736 201.543 146.885 205.395 146.885 205.395C149.148 200.274 154.879 184.485 156.34 184.328C157.784 184.174 153.828 196.003 153.723 196.314C159.96 183.849 164.945 183.733 165.837 184.88C166.717 186.01 156.977 196.828 156.686 197.151C163.199 191.727 166.162 192.09 164.811 193.034Z",
    fill: "url(#paint0_linear_2_649)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.462 197.793C139.982 198.025 139.497 198.243 139.018 198.449C136.043 194.984 133.24 192.032 133.24 192.032C133.24 192.032 131.122 189.092 133.934 191.042C135.175 191.904 137.856 194.818 140.462 197.793Z",
    fill: "url(#paint1_linear_2_649)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.709 27.3491C118.709 27.3491 105.649 18.3059 109.919 6.47388C114.189 -5.35519 118.709 27.3491 118.709 27.3491Z",
    fill: "#282827"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.27 27.349C119.27 27.349 122.988 2.56663 131.288 0.158399C139.59 -2.24983 126.274 23.5406 119.27 27.349Z",
    fill: "#282827"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.997 174.814C152.151 182.992 145.243 189.734 137.17 194.054C127.86 199.036 117.248 198.531 107.113 197.95C87.6812 196.84 67.9215 193.772 51.8977 181.086C45.5764 176.078 40.0918 170.03 36.4228 163.473C34.2296 159.56 32.3907 155.308 31.5018 150.845C31.252 149.62 30.3776 146.95 31.3449 145.826C31.5134 145.628 31.9666 145.474 32.5011 145.387C33.3407 145.25 34.3748 145.268 34.7815 145.524C34.9151 145.611 34.9791 145.727 34.9442 145.869C35.3654 144.179 34.9762 142.197 35.4235 140.408C35.4991 140.364 35.5862 140.338 35.6792 140.327C36.937 140.097 39.4353 142.11 40.0221 143.173C40.0366 143.205 40.057 143.24 40.0744 143.278C39.5806 142.2 40.7513 140.919 41.8726 140.995C42.991 141.07 43.8944 141.997 44.5858 142.95C46.9418 146.2 47.6157 147.319 51.2092 146.343C54.2943 145.506 57.3387 144.379 60.081 142.616C66.7799 138.308 70.8381 130.668 73.3567 122.676C74.1876 120.059 77.8217 92.4409 77.8275 88.8852C78.9227 88.9665 79.9104 90.7037 80.6221 91.4793C81.6998 92.65 82.4551 93.9311 83.2802 95.2994C88.207 103.445 95.359 109.961 102.424 116.349C112.748 125.665 124.028 135.374 137.839 137.076C140.627 137.416 143.515 137.398 146.176 136.489C150.283 135.083 153.369 131.716 156.082 128.329C158.374 125.473 159.69 122.949 160.657 119.425C161.273 117.197 160.797 108.52 163.118 107.646C163.606 107.46 164.553 126.513 164.556 127.899C164.608 144.35 165.567 160.348 156.997 174.814Z",
    fill: "#D6D6D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7986 154.979C39.7986 154.979 35.3598 147.749 32.4984 145.39C33.338 145.253 34.3721 145.271 34.7788 145.526C34.8456 145.637 34.895 145.75 34.9415 145.872C34.9415 145.872 37.8087 150.447 39.7986 154.979Z",
    fill: "url(#paint2_linear_2_649)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6733 140.326C36.9312 140.097 39.4295 142.11 40.0163 143.173C40.0308 143.205 40.0511 143.24 40.0686 143.278C40.0686 143.278 44.3796 149.765 45.4689 152.106C46.5583 154.442 37.9973 142.313 35.6733 140.326Z",
    fill: "url(#paint3_linear_2_649)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.228 152.606C124.252 151.691 88.8201 109.964 77.816 89.6724C77.816 89.6666 77.8102 89.6637 77.8102 89.6579C77.9002 88.0514 78.0164 86.3549 78.1762 84.5916C80.0761 63.4782 87.4663 32.8597 112.827 26.8755C112.827 26.8755 138.585 21.1149 153.189 48.6076C156.16 54.1968 158.67 61.16 160.405 69.8314C161.622 75.8941 162.458 82.7963 162.819 90.6398C163.06 96.0198 163.158 101.382 163.121 106.698L163.022 112.651L163.013 112.88C163.013 112.88 163.013 112.886 163.01 112.901C162.938 113.958 159.954 153.512 142.228 152.606Z",
    fill: "#282827"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.228 152.606C124.252 151.691 88.8201 109.964 77.816 89.6725C77.816 89.6667 77.8102 89.6638 77.8102 89.658C77.9002 88.0515 78.0164 86.355 78.1762 84.5917C78.182 84.6004 78.182 84.6004 78.182 84.6004C78.182 84.6004 151.19 181.888 163.121 106.699L163.022 112.651L163.013 112.88C163.013 112.88 163.013 112.886 163.01 112.901C162.938 113.958 159.954 153.512 142.228 152.606Z",
    fill: "#373737"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1535 40.9472C94.1535 40.9472 105.602 24.7607 123.488 27.7063C141.377 30.652 84.9331 55.7161 94.1535 40.9472Z",
    fill: "url(#paint4_linear_2_649)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.839 106.077C136.839 106.077 137.458 114.01 139.149 115.335C140.839 116.66 141.025 106.077 141.025 106.077H136.839Z",
    fill: "url(#paint5_linear_2_649)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.368 64.4369C128.223 74.8396 121.184 83.174 112.644 83.0578C104.103 82.9387 97.2967 74.4126 97.442 64.0099C97.5872 53.6071 104.626 45.2728 113.167 45.389C121.707 45.5081 128.514 54.0342 128.368 64.4369Z",
    fill: "url(#paint6_linear_2_649)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.311 65.6888C127.177 75.3914 120.609 83.1652 112.644 83.0577C104.678 82.9473 98.331 74.9935 98.4646 65.2937C98.5982 55.5911 105.166 47.8174 113.132 47.9249C121.097 48.0353 127.445 55.9891 127.311 65.6888Z",
    fill: "url(#paint7_radial_2_649)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.588 65.4563C126.635 62.0698 124.42 59.293 121.64 59.254C118.86 59.2151 116.568 61.9289 116.52 65.3154C116.473 68.7018 118.688 71.4787 121.468 71.5176C124.248 71.5565 126.541 68.8428 126.588 65.4563Z",
    fill: "#282827"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.187 63.821C120.83 64.8058 118.48 64.5007 115.938 63.1441C113.396 61.7875 111.627 59.8876 111.987 58.9029C112.345 57.9181 114.695 58.2231 117.237 59.5797C119.776 60.9363 121.545 62.8362 121.187 63.821Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.34 67.1849C118.686 68.2307 118.387 69.3695 117.672 69.7239C116.955 70.0812 116.095 69.5205 115.749 68.4747C115.404 67.4289 115.703 66.2902 116.417 65.9358C117.132 65.5814 117.992 66.1391 118.34 67.1849Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.407 69.8314C158.964 75.4642 155.437 79.4643 151.257 79.5282C145.67 79.6241 141.025 72.6754 140.886 64.0215C140.738 55.3675 145.153 48.2765 150.74 48.1835C151.582 48.169 152.404 48.3142 153.191 48.6076C156.163 54.1968 158.676 61.1601 160.407 69.8314Z",
    fill: "url(#paint8_linear_2_649)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.448 64.7564C160.582 72.8294 156.468 79.444 151.257 79.5312C146.048 79.6183 141.717 73.1431 141.583 65.0673C141.449 56.9943 145.563 50.3797 150.774 50.2926C155.986 50.2054 160.314 56.6835 160.448 64.7564Z",
    fill: "url(#paint9_radial_2_649)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M146.977 69.2626C148.795 69.2324 150.231 66.9243 150.184 64.1073C150.137 61.2903 148.626 59.0312 146.808 59.0613C144.991 59.0915 143.555 61.3996 143.602 64.2166C143.649 67.0336 145.16 69.2928 146.977 69.2626Z",
    fill: "#282827"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M146.603 62.8595C146.33 63.6439 145.139 63.6903 143.942 62.967C142.745 62.2436 141.998 61.0236 142.272 60.2392C142.545 59.4549 143.736 59.4084 144.932 60.1317C146.129 60.8551 146.876 62.0752 146.603 62.8595Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.81 65.718C145.06 66.5808 144.892 67.5336 144.43 67.8444C143.971 68.1553 143.393 67.7108 143.143 66.848C142.893 65.9853 143.062 65.0324 143.524 64.7216C143.985 64.4079 144.561 64.8552 144.81 65.718Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M159.167 43.3148L150.368 35.5149C150.034 35.2186 149.499 35.2593 149.22 35.5992L147.187 38.0771C146.902 38.4228 147.015 38.9224 147.425 39.1374L158.107 44.6888C158.47 44.8777 158.929 44.7673 159.144 44.4361L159.295 44.2066C159.484 43.919 159.431 43.5501 159.167 43.3148Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.311 39.4075L115.932 33.8939C116.333 33.6847 116.844 33.8474 117.021 34.2425L118.323 37.1126C118.506 37.5135 118.262 37.9725 117.809 38.0829L105.971 40.982C105.57 41.0808 105.155 40.8658 105.036 40.4969L104.951 40.2413C104.844 39.9188 104.995 39.5731 105.311 39.4075Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5557 153.201C54.7038 153.14 54.8316 153.088 54.9362 153.047C54.8084 153.105 54.6835 153.155 54.5557 153.201Z",
    fill: "url(#paint10_linear_2_649)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6678 196.282C98.6678 196.282 87.4168 203.908 83.7885 208.094C83.7885 208.094 88.3464 221.207 86.6702 223.066C84.9969 224.925 83.2307 210.883 78.5799 205.026C73.929 199.17 68.7233 191.727 67.6077 190.519C66.4922 189.31 69.467 189.589 74.6756 196.285C74.6756 196.285 67.2359 183.265 68.3514 182.335C69.4669 181.406 74.3183 182.582 77.7432 196.099C77.7432 196.099 76.3488 183.358 77.7432 183.823C79.1376 184.288 81.3687 200.933 82.4871 206.421C82.4871 206.421 95.0424 196.471 98.203 195.167C101.364 193.865 98.6678 196.282 98.6678 196.282Z",
    fill: "url(#paint11_linear_2_649)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.089 91.6275C133.089 91.6275 128.851 76.7714 136.035 69.5642C143.219 62.3569 144.366 79.8623 143.802 81.3961C143.242 82.93 133.089 91.6275 133.089 91.6275Z",
    fill: "#1A1718"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.725 108.11C138.19 109.168 140.023 109.978 140.909 109.435C141.348 109.191 141.548 108.61 141.261 107.576C141.15 107.187 141.075 106.562 141.011 105.775C140.996 105.647 140.988 105.49 140.982 105.348C140.642 99.5784 141.31 86.4362 141.055 84.2808C140.744 81.7447 135.175 75.2172 133.324 85.1581C132.412 90.0239 133.443 95.6421 134.748 100.101C136.101 104.732 137.725 108.11 137.725 108.11Z",
    fill: "url(#paint12_linear_2_649)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.725 108.11C138.19 109.168 140.023 109.978 140.909 109.435C141.278 108.381 141.023 107.282 141.023 107.282C141.023 107.282 141.057 106.675 141.011 105.778C140.996 105.65 140.988 105.493 140.982 105.351C140.886 104.162 140.619 102.646 139.983 101.391C138.739 98.9655 137.76 101.272 137.76 101.272C136.95 98.7098 134.919 99.9851 134.745 100.107C136.101 104.732 137.725 108.11 137.725 108.11Z",
    fill: "url(#paint13_linear_2_649)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.072 106.478C141.072 106.478 142.013 108.096 142.205 109.36C142.205 109.36 140.032 110.135 140.006 110.054C139.98 109.972 140.761 109.551 140.895 108.476C141.028 107.404 141.072 106.478 141.072 106.478Z",
    fill: "url(#paint14_linear_2_649)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.092 86.4683C133.092 86.4683 132.979 75.653 138.861 72.6173C144.744 69.5816 146.039 86.3898 146.063 89.4488C146.063 89.4488 139.887 84.0862 133.092 86.4683Z",
    fill: "url(#paint15_linear_2_649)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 106.768C137.121 106.768 139.77 109.301 142.205 109.36C142.205 109.36 139.387 113.063 137.121 106.768Z",
    fill: "url(#paint16_linear_2_649)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.945 74.4533C139.32 74.6392 141.171 76.0452 140.953 78.8572C140.735 81.6692 136.398 73.178 138.945 74.4533Z",
    fill: "url(#paint17_linear_2_649)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7382 134.339C93.0875 137.262 89.8164 138.755 84.1227 137.947C75.4978 136.704 52.6153 128.294 40.7979 118.173C28.9717 108.052 38.5697 107.001 38.5697 107.001C38.5697 107.001 38.5494 106.992 38.5087 106.974C30.5433 103.561 26.395 100.598 24.559 98.0911C19.8007 91.5984 30.5433 88.1967 30.5433 88.1967C20.5647 84.4086 13.1918 79.0373 8.59034 74.0407C5.87999 71.1009 4.12829 68.286 3.36428 65.9969C2.07157 62.1216 3.61702 59.7483 8.14007 60.7766C19.8907 63.4521 57.1994 68.1727 65.8155 80.5682C74.4404 92.9492 92.6052 128.797 92.6052 128.797C93.7062 130.935 94.0723 132.829 93.7382 134.339Z",
    fill: "#282827"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36148 65.9997C18.6271 72.5882 49.3821 78.5115 56.0636 83.142C65.0342 89.3587 65.9492 104.087 71.0533 111.698C74.8007 117.307 87.3648 128.707 93.7383 134.339C94.0753 132.829 93.7063 130.935 92.6053 128.794C92.6053 128.794 74.4405 92.9521 65.8156 80.5653C57.1966 68.1726 19.8908 63.4521 8.13726 60.7766C3.61421 59.7511 2.06876 62.1245 3.36148 65.9997Z",
    fill: "#1A1718"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5529 96.2522C50.268 94.7794 30.5403 88.1996 30.5403 88.1996C20.5617 84.4115 13.1889 79.0402 8.5874 74.0436C30.5636 84.7892 58.8406 97.7221 54.5529 96.2522Z",
    fill: "url(#paint18_linear_2_649)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.666 116.555C63.4015 114.789 38.5669 107.001 38.5669 107.001C38.5669 107.001 38.5465 106.992 38.5059 106.974C30.5404 103.561 26.3921 100.598 24.5562 98.0911C46.91 103.021 71.9335 118.316 67.666 116.555Z",
    fill: "url(#paint19_linear_2_649)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M215.155 84.5829C211.948 87.6448 207.651 90.8083 202.265 93.568C202.265 93.568 192.42 98.0388 189.919 99.3519C187.418 100.665 196.383 92.348 215.146 84.5888C215.152 84.5888 215.152 84.5829 215.155 84.5829Z",
    fill: "url(#paint20_linear_2_649)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M207.918 99.4883C206.8 101.531 203.738 104.247 197.304 107.843C197.304 107.843 187.27 112.581 183.005 115.451C178.738 118.316 190.759 105.67 207.918 99.4883Z",
    fill: "url(#paint21_linear_2_649)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.09 159.011C161.09 159.011 155.204 191.812 122.399 196.515C89.5926 201.215 167.954 138.831 161.09 159.011Z",
    fill: "url(#paint22_linear_2_649)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4411 67.3651C39.4411 67.3651 35.7024 68.7652 37.4135 76.5506L44.1705 78.5056C44.1705 78.5056 41.2132 73.1663 45.5648 69.14C45.5648 69.14 40.3562 67.6062 39.4411 67.3651Z",
    fill: "#D6D6D6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M200.781 77.2449C200.781 77.2449 204.133 79.5747 201.905 83.7201L207.555 81.37C207.555 81.37 210.216 77.7998 207.056 75.0865L200.781 77.2449Z",
    fill: "#D6D6D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_649",
    x1: 149.183,
    y1: 178.473,
    x2: 149.183,
    y2: 220.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_649",
    x1: 131.767,
    y1: 189.969,
    x2: 139.38,
    y2: 197.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_649",
    x1: 41.4381,
    y1: 146.167,
    x2: 36.5556,
    y2: 149.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_649",
    x1: 48.541,
    y1: 140.286,
    x2: 40.8565,
    y2: 146.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_649",
    x1: 88.5914,
    y1: -10.0957,
    x2: 110.577,
    y2: 37.9855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_649",
    x1: 142.996,
    y1: 94.1011,
    x2: 143.076,
    y2: 115.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_649",
    x1: 113.846,
    y1: -3.94917,
    x2: 112.768,
    y2: 74.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_649",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.888 65.491) rotate(0.793085) scale(14.4236 17.5683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_649",
    x1: 158.02,
    y1: 7.88466,
    x2: 149.879,
    y2: 71.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2_649",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.015 64.9112) rotate(-0.946082) scale(9.43338 14.6209)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_649",
    x1: 54.7423,
    y1: 153.116,
    x2: 54.7485,
    y2: 153.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A499B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_649",
    x1: 83.557,
    y1: 173.781,
    x2: 83.557,
    y2: 221.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_649",
    x1: 132.812,
    y1: 76.0262,
    x2: 143.078,
    y2: 108.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A62F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_649",
    x1: 136.43,
    y1: 97.643,
    x2: 140.205,
    y2: 109.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C05E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_649",
    x1: 143.709,
    y1: 106.995,
    x2: 141.626,
    y2: 107.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_649",
    x1: 135.134,
    y1: 70.6791,
    x2: 141.471,
    y2: 90.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_649",
    x1: 138.843,
    y1: 105.467,
    x2: 140.415,
    y2: 110.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_649",
    x1: 145.913,
    y1: 72.4477,
    x2: 138.873,
    y2: 77.3459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_649",
    x1: 22.448,
    y1: 106.143,
    x2: 32.1576,
    y2: 84.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_649",
    x1: 41.5496,
    y1: 118.733,
    x2: 46.4044,
    y2: 107.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_649",
    x1: 207.663,
    y1: 101.06,
    x2: 201.877,
    y2: 91.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_649",
    x1: 202.158,
    y1: 118.521,
    x2: 194.435,
    y2: 106.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_649",
    x1: 178.798,
    y1: 213.409,
    x2: 137.018,
    y2: 174.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird2);
export default __webpack_public_path__ + "static/media/Bird2.4953fac07c1bd73101562344d85189af.svg";
export { ForwardRef as ReactComponent };